import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  input,
  ViewChild,
} from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { TranslocoModule } from "@ngneat/transloco";
import { MatTreeModule, MatTree } from "@angular/material/tree";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { TreeNode } from "@core/services/tree-builder.service";
import { UserStateService } from "@core/services/common/user-state.service";

@Component({
  selector: "tree-menu",
  templateUrl: "tree-menu.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["tree-menu.component.scss"],
  standalone: true,
  imports: [
    MatIconModule,
    TranslocoModule,
    MatButtonModule,
    RouterModule,
    MatTreeModule,
  ],
})
export class TreeMenuComponent {
  private readonly router = inject(Router);
  private readonly userState = inject(UserStateService);

  @ViewChild("tree") public tree!: MatTree<TreeNode>;

  public readonly dataMenuTree = input.required<TreeNode[]>();
  public readonly childrenAccessor = (node: TreeNode): TreeNode[] => node.children ?? [];
  public readonly hasChild = (_: number, node: TreeNode): boolean => node.tipo === "M";
  public readonly routing = this.userState.routing;

  @HostListener("contextmenu", ["$event"])
  public onRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  public handleLinkInteraction(event: MouseEvent, path: string): void {
    const abrirEnNuevaPestana = event.button === 1 || event.ctrlKey || event.metaKey;
    if (abrirEnNuevaPestana) {
      event.preventDefault();
      this.openInNewTab(path);
    }
  }

  public isNodeExpanded(node: TreeNode): boolean {
    return this.tree?.isExpanded(node) || false;
  }

  private openInNewTab(path: string): void {
    const urlTree = this.router.createUrlTree([path]);
    const serializedUrl = this.router.serializeUrl(urlTree);
    window.open(serializedUrl, "_blank");
  }
}
